import { axiosBasic } from "../../../../../api/axios";
import { config } from "../../../../../api/endPoints";

const { CompanyAutoLeaveSettings, LeaveType } = config.REST_API;

const unwrap = (res) => {
  const body = res?.data;
  if (body && typeof body === "object" && "success" in body && body.success === false) {
    throw new Error(body.message || "Request failed");
  }
  return body?.data ?? body;
};

export const getAutoLeaveSettings = () =>
  axiosBasic.get(CompanyAutoLeaveSettings.ByCompany).then(unwrap);

export const saveAutoLeaveSettings = (payload) =>
  axiosBasic.post(CompanyAutoLeaveSettings.Save, payload).then(unwrap);

export const getCompanyLeaveTypes = () =>
  axiosBasic.get(LeaveType.GetLeaveTypesOfCompany).then((res) => {
    const body = res?.data;
    const data = body?.data ?? body;
    return Array.isArray(data) ? data : [];
  });
